import _objectWithoutProperties from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["disabled", "onClick", "children", "twStyle", "StartIcon", "EndIcon", "newTab", "href", "size", "variant", "iconStyle"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _styled from "styled-components";
import { forwardRef, useCallback } from 'react';
import NextLink from 'next/link';
import { useNavigationContext } from '@restworld/utils-common';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var LINK_DELAY = 200; // eslint-disable-next-line jsx-a11y/anchor-has-content

var ForwardedLink = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/_jsx("a", _objectSpread({
    ref: ref
  }, props));
});
ForwardedLink.displayName = 'ForwardedLink';
var DEFAULT_HREF = '#!';
export var Link = /*#__PURE__*/forwardRef(function (props, ref) {
  var disabled = props.disabled,
      onClick = props.onClick,
      children = props.children,
      twStyle = props.twStyle,
      StartIcon = props.StartIcon,
      EndIcon = props.EndIcon,
      _props$newTab = props.newTab,
      newTab = _props$newTab === void 0 ? true : _props$newTab,
      _props$href = props.href,
      href = _props$href === void 0 ? DEFAULT_HREF : _props$href,
      _props$size = props.size,
      size = _props$size === void 0 ? 'md' : _props$size,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'neutral' : _props$variant,
      iconStyle = props.iconStyle,
      restProps = _objectWithoutProperties(props, _excluded);

  var _useNavigationContext = useNavigationContext(),
      router = _useNavigationContext.router;

  var iconClasses = iconStyle || 'h-4 w-4';
  var handleClick = useCallback(function (e) {
    e.preventDefault();
    if (disabled) return;
    onClick && onClick(e);
    setTimeout(function () {
      if (newTab) {
        window.open(href, '_blank', 'noopener noreferrer');
      } else {
        href !== DEFAULT_HREF && router.push(href);
      }
    }, LINK_DELAY);
  }, [disabled, href, newTab, onClick, router]);
  return /*#__PURE__*/_jsx(NextLink, {
    as: "div",
    href: href,
    passHref: true,
    legacyBehavior: true,
    children: /*#__PURE__*/_jsxs(StyledLink //@ts-expect-error - ref type is not properly inferred
    , _objectSpread(_objectSpread({
      ref: ref,
      variant: variant,
      size: size,
      disabled: disabled,
      onClick: function onClick(e) {
        return handleClick(e);
      },
      target: newTab ? '_blank' : undefined,
      rel: newTab ? 'noopener noreferrer' : undefined,
      twStyle: twStyle
    }, restProps), {}, {
      children: [StartIcon && /*#__PURE__*/_jsx(StartIcon, {
        className: iconClasses
      }), children, EndIcon && /*#__PURE__*/_jsx(EndIcon, {
        className: iconClasses
      })]
    }))
  });
});
Link.displayName = 'Link';
export default Link;

var StyledLink = /*#__PURE__*/_styled(ForwardedLink).withConfig({
  displayName: "link__StyledLink",
  componentId: "sc-x9xi0m-0"
})(["", " ", " ", " ", " ", ""], {
  "display": "flex",
  "width": "fit-content",
  "alignItems": "center",
  "gap": "0.5rem",
  "borderRadius": "0.5rem",
  "fontWeight": "500",
  "color": "inherit",
  "textDecorationLine": "none",
  "transitionProperty": "color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter",
  "transitionTimingFunction": "cubic-bezier(0.4, 0, 0.2, 1)",
  "transitionDuration": "200ms",
  ":hover": {
    "cursor": "pointer"
  },
  ":focus-visible": {
    "outlineWidth": "8px",
    "outlineColor": "#e88a99"
  }
}, function (_ref) {
  var size = _ref.size;
  return size === 'sm' ? {
    "height": "2rem",
    "padding": "0.25rem",
    "fontSize": "0.875rem",
    "lineHeight": "1.25rem"
  } : {
    "height": "2.5rem",
    "paddingTop": "0.25rem",
    "paddingBottom": "0.25rem",
    "paddingLeft": "0.5rem",
    "paddingRight": "0.5rem",
    "fontSize": "1rem",
    "lineHeight": "1.5rem"
  };
}, function (_ref2) {
  var variant = _ref2.variant;

  switch (variant) {
    case 'success':
      return {
        "--tw-text-opacity": "1",
        "color": "rgb(0 84 45 / var(--tw-text-opacity))",
        ":hover": {
          "backgroundColor": "rgb(0 84 45 / 0.1)"
        },
        ":active": {
          "backgroundColor": "rgb(0 84 45 / 0.2)"
        }
      };

    case 'warning':
      return {
        "--tw-text-opacity": "1",
        "color": "rgb(158 84 0 / var(--tw-text-opacity))",
        ":hover": {
          "backgroundColor": "rgb(158 84 0 / 0.1)"
        },
        ":active": {
          "backgroundColor": "rgb(158 84 0 / 0.2)"
        }
      };

    case 'error':
      return {
        "--tw-text-opacity": "1",
        "color": "rgb(145 0 24 / var(--tw-text-opacity))",
        ":hover": {
          "backgroundColor": "rgb(145 0 24 / 0.1)"
        },
        ":active": {
          "backgroundColor": "rgb(145 0 24 / 0.2)"
        }
      };

    case 'restworld':
      return {
        "--tw-text-opacity": "1",
        "color": "rgb(72 36 133 / var(--tw-text-opacity))",
        ":hover": {
          "backgroundColor": "rgb(72 36 133 / 0.1)"
        },
        ":active": {
          "backgroundColor": "rgb(72 36 133 / 0.2)"
        }
      };

    case 'reversed':
      return {
        "--tw-text-opacity": "1",
        "color": "rgb(255 255 255 / var(--tw-text-opacity))",
        ":hover": {
          "backgroundColor": "rgb(255 255 255 / 0.1)"
        }
      };

    default:
      return {
        "--tw-text-opacity": "1",
        "color": "rgb(28 28 51 / var(--tw-text-opacity))",
        ":hover": {
          "backgroundColor": "rgb(0 0 26 / 0.1)"
        },
        ":active": {
          "backgroundColor": "rgb(0 0 26 / 0.2)"
        }
      };
  }
}, function (_ref3) {
  var disabled = _ref3.disabled;
  return disabled ? {
    "--tw-text-opacity": "1",
    "color": "rgb(117 117 131 / var(--tw-text-opacity))",
    ":hover": {
      "cursor": "not-allowed",
      "backgroundColor": "transparent"
    }
  } : {};
}, function (_ref4) {
  var twStyle = _ref4.twStyle;
  return twStyle || {};
});